import type { RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';

const { $gettext } = gettext;

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'login',
    component: () => import('src/pages/LoginPage.vue'),
  },
  {
    path: 'signup-free',
    alias: $gettext('registrace-zdarma'),
    name: 'signupFree',
    component: () => import('src/pages/SignUpPageFree.vue'),
  },
  {
    path: 'password-reset',
    alias: $gettext('obnova-hesla'),
    name: 'resetEmail',
    component: () => import('src/pages/ResetEmailPage.vue'),
  },
  {
    path: 'resetpassword/:uid/:token',
    alias: $gettext('resetpassword/:uid/:token'),
    name: 'resetPassword', // IF CHANGED - needs to be changed in layouts/AppAuthLayout.vue as well
    props: true,
    component: () => import('src/pages/ResetPasswordPage.vue'),
  },
];
